import type React from 'react';
import {useState} from 'react';
import {ProfileCompletionIndicator} from './ProfileCompletionIndicator';
import {ProfileDetailList} from './ProfileDetailList';
import {SelfPRSection} from './SelfPRSection';
import {UniversityInfoSection} from './UniversityInfoSection';
import {UserNameSection} from './UserNameSection';
import type {Profile, University, User} from './types';

export type ProfileBoxProps = {
  user: User;
  university: University;
  profile: Profile;
  showCompletionIndicator?: boolean;
  onCloseCompletionIndicator: () => void;
};

export const ProfileBoxPresentation: React.FC<ProfileBoxProps> = ({
  user,
  university,
  profile,
  showCompletionIndicator = true,
  onCloseCompletionIndicator,
}) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const handleToggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <>
      <div className="hidden pc:flex flex-col w-full gap-8">
        <div className="bg-white p-16 rounded-16 gap-16 flex flex-col">
          {showCompletionIndicator && (
            <ProfileCompletionIndicator
              inputRate={profile.inputRate}
              firstUnfilledFieldLabel={profile.firstUnfilledFieldLabel}
              requiredAction={profile.requiredAction}
              onClose={onCloseCompletionIndicator}
            />
          )}
          <div className="flex items-stretch gap-16">
            <UserNameSection
              user={user}
              isExpanded={isExpanded}
              onToggleExpanded={handleToggleExpanded}
            />
            <UniversityInfoSection university={university} />
            <SelfPRSection pr={profile.pr} />
          </div>
        </div>
        {isExpanded && (
          <ProfileDetailList unfilledFields={profile.unfilledFields} />
        )}
      </div>

      <div className="flex flex-col w-full gap-8 pc:hidden">
        <div className="bg-white p-16 rounded-16 gap-16 flex flex-col">
          {showCompletionIndicator && (
            <ProfileCompletionIndicator
              inputRate={profile.inputRate}
              firstUnfilledFieldLabel={profile.firstUnfilledFieldLabel}
              requiredAction={profile.requiredAction}
              onClose={onCloseCompletionIndicator}
            />
          )}
          <div className="flex flex-col gap-8">
            <UserNameSection user={user} isExpanded={isExpanded} />
            <UniversityInfoSection university={university} />
          </div>
        </div>
      </div>
    </>
  );
};
